import { render, staticRenderFns } from "./withdraw_list.vue?vue&type=template&id=422ab87f&scoped=true"
import script from "./withdraw_list.vue?vue&type=script&lang=js"
export * from "./withdraw_list.vue?vue&type=script&lang=js"
import style0 from "./withdraw_list.vue?vue&type=style&index=0&id=422ab87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ab87f",
  null
  
)

export default component.exports